module.exports = __webpack_public_path__ + "static/media/Search.0239abce.svg";